module.exports = __webpack_public_path__ + "static/media/Screen Shot 2022-05-30 at 2.25.23 PM.115911e4.png";